<div class="isg-full-page-header">

  <div class="isg-page-header">

    <button kendoButton type="button" class="isg-button-icon" (click)="onLicensesClick()">
      <span class="fas fa-table" title="Back to licenses"></span>
    </button>

    <span>Role Template Management</span>

  </div>
  <div class="isg-page-body">

    <div class="isg-roletemplate-page" [class.isg-module-hide]="hideModule">

      <div class="isg-module" [ngClass]="{'isg-module-hide': hideModule}" style="margin-right:24px;">


        <div class="isg-subheader">
          <span>Modules</span>
        </div>
        <div class="isg-module-list">
          <app-modules-list [includeHost]="true"
                            (selected)="onModuleSelected($event)"
                            (dataLoaded)="onModulesLoaded($event)">
          </app-modules-list>
        </div>
      </div>

      <div class="isg-roletemplate">

        <div class="isg-subheader">
          <span>Role Templates </span>
        </div>

        <div class="isg-roletemplate-grid-wrapper">
          <span id="isgId-roletemplate-text">View and remove templates. For assigning and viewing permissions please go to the roles page for the ISG license where one can review and create role templates across the application.</span>
          <app-role-template-grid [disableOnSizingLocal]="true">

          </app-role-template-grid>

        </div>
      </div>
    </div>

  </div>

</div>
